var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowLeftDisabled = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3n-web/icon/left-arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3n-web/icon/left-arrow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3n-web/icon/expand-copy-2",
    transform: "translate(15, 15) rotate(90) translate(-15, -15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Nav/Menu-Default",
    transform: "translate(5.9878, 11.0122)",
    fill: "#bfbfbf",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4227891,-3.15069642 C12.7958523,-3.76597038 11.7916991,-3.76597038 11.1647623,-3.15069642 L4.2376769,3.64752482 C3.44751739,4.42298504 3.40447152,5.67242159 4.11695625,6.49934679 L4.2376769,6.6281714 L4.2376769,6.6281714 L11.1647623,13.4263926 C11.7916991,14.0416666 12.7958523,14.0416666 13.4227891,13.4263926 C14.0347264,12.8258392 14.0439548,11.8429213 13.4434014,11.230984 L7.23515732,5.13784811 L13.4227891,-0.934675537 C14.0055865,-1.50663119 14.0417092,-2.4254027 13.5250473,-3.04022222 L13.4227891,-3.15069642 L13.4227891,-3.15069642 Z",
    id: "Path",
    transform: "translate(8.75, 5.1378) scale(-1, 1) rotate(-90) translate(-8.75, -5.1378)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowLeftDisabled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-arrow-left-disabled.8d48bb4a9a98dbc2ee01c690d648c794.svg";